module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"AresLoading":{"button":"Načíst údaje z ARES"}},"en":{"AresLoading":{"button":"Retrieve data from ARES"}}}')
  delete Component.options._Ctor
}
